import script from "./tableModal.vue?vue&type=script&setup=true&lang=js"
export * from "./tableModal.vue?vue&type=script&setup=true&lang=js"

import "./tableModal.vue?vue&type=style&index=0&id=c9122f38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9122f38"]])

export default __exports__